import { Box, Stack, Typography } from "@mui/material"
import first from "lodash/first"

import type { FC } from ".."
import { BlogArticleTeaser, Container, Link } from ".."
import { BlogArticleTeaserProps } from "../BlogArticleTeaser/BlogArticleTeaser"

type TrendingBlogPostsProps = {
  title?: string
  uri: string
  items: BlogArticleTeaserProps[]
  onLike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
  onUnlike?: (arg: { contentType?: string; nid?: number }, arg2?: string) => void
  componentType?: string
}

const TrendingBlogPosts: FC<TrendingBlogPostsProps> = ({
  title = "Trending",
  uri,
  items,
  onLike,
  onUnlike,
  componentType,
}) => {
  const featured = first(items)
  const rest = items.slice(1)

  return (
    <Container py={{ xs: 15, md: 30 }}>
      <Stack direction="row" justifyContent="space-between" mb={10}>
        <Typography variant="heading.xl" component="h2">
          {title}
        </Typography>
        <Link
          href={uri}
          type="base"
          variant="link.sm"
          sx={{
            borderRadius: 1,
            border: (theme) => `1px solid ${theme.palette["neutral.200"].main}`,
            display: { xs: "none", md: "inline-flex" },
            alignItems: "center",
            justifyContent: "center",
            height: 50,
            px: 7,
            py: 3.5,
          }}
        >
          View All
        </Link>
      </Stack>

      <Box
        display="grid"
        gridTemplateColumns={{
          md: "clamp(0px, 55%, 994px) 1fr",
          lg: "clamp(0px, 65.56%, 994px) 1fr",
        }}
        columnGap={10}
        rowGap={4}
      >
        <Box>
          <Box position="sticky" top={0}>
            {featured && (
              <BlogArticleTeaser
                onLike={onLike}
                onUnlike={onUnlike}
                componentType={componentType}
                {...featured}
                featured
              />
            )}
          </Box>
        </Box>
        <Stack rowGap={{ xs: 4, md: 10 }}>
          {rest.map((item, i) => (
            <BlogArticleTeaser
              key={i}
              onLike={onLike}
              onUnlike={onUnlike}
              componentType={componentType}
              {...item}
            />
          ))}
        </Stack>
      </Box>
      <Box px={2.5} pt={12} display={{ md: "none" }}>
        <Link
          href={uri}
          type="base"
          variant="link.sm"
          sx={{
            borderRadius: 1,
            border: (theme) => `1px solid ${theme.palette["neutral.200"].main}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 50,
            px: 7,
            py: 3.5,
          }}
        >
          View All
        </Link>
      </Box>
    </Container>
  )
}
export default TrendingBlogPosts
